import React from 'react';
import { Grid, Card, CardContent, Typography, Button, Box } from '@mui/material';

// Dummy data for services
const services = [
  {
    title: 'VPN Solutions',
    description: 'Protect your data and systems with our advanced VPN technology, ensuring privacy and security online.',
    imageUrl: 'https://img.freepik.com/free-vector/blue-futuristic-networking-technology_53876-100679.jpg',
    serviceLink: '#',
  },
  {
    title: 'Mobile App Development',
    description: 'Build custom mobile apps designed to meet your business needs and deliver seamless user experiences.',
    imageUrl: 'https://img.freepik.com/free-vector/blue-futuristic-networking-technology_53876-100679.jpg',
    serviceLink: '#',
  },
  {
    title: 'Software Development',
    description: 'Develop high-performance software solutions tailored to your specific business requirements.',
    imageUrl: 'https://img.freepik.com/free-vector/blue-futuristic-networking-technology_53876-100679.jpg',
    serviceLink: '#',
  },
];

const ServiceSection = () => {
  return (
    <section id="services" style={{backgroundColor: '#333', color: 'white', padding: '60px 20px' }}>
      <Box sx={{ maxWidth: '1200px', margin: '0 auto' }}>
        <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold' }}>
          Our Services
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {services.map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card sx={{ boxShadow: 5, borderRadius: 2, overflow: 'hidden', backgroundColor: '#fff' }}>
                <img 
                  src={service.imageUrl} 
                  alt={service.title} 
                  style={{ width: '100%', height: '200px', objectFit: 'cover' }} 
                />
                <CardContent sx={{ padding: '20px' }}>
                  <Typography variant="h5" gutterBottom sx={{ fontWeight: 'bold' }}>
                    {service.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" paragraph>
                    {service.description}
                  </Typography>
                  <Button 
                    variant="contained" 
                    color="primary" 
                    href={service.serviceLink} 
                    sx={{ textTransform: 'none', marginTop: 2 }}>
                    Learn More
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </section>
  );
};

export default ServiceSection;
